import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/overview')({
  beforeLoad: () => getTitleContextSlice('Dashboard'),
  staticData: {
    owner: CodeOwner.IDNP,
  },
});
